import React from 'react';



interface Partner {
  id: string;
  name: string;
  logo: string;
  alt: string;
  type: string;
  collaboration: string;
}

interface ResearchPartnersProps {
  partners: Partner[];
}

const ResearchPartners = ({ partners }: ResearchPartnersProps) => {
  return;




































































};

export default ResearchPartners;